<template>
    <div>
        <label :for="labelFor" v-if="labelFor.length > 0">
            {{ labelPlaceholder }}
        </label>
        <input
            type="text"
            class="form-control city-input"
            :placeholder="placeholder"
            :name="name"
            :value="value"
            readonly
        >
    </div>
</template>

<script>
export default {
    props: {
        type: {
            required: false,
            type: String,
            default: 'account'
        },
        name: {
            required: true,
            type: String
        },
        id: {
            required: false,
            type: String,
            default: ''
        },
        placeholder: {
            required: true,
            type: String
        },
        valueProp: {
            required: false,
            type: String,
            default: null
        },
        labelFor: {
            required: false,
            type: String,
            default: ''
        },
        labelPlaceholder: {
            required: false,
            type: String
        }
    },

    data() {
        return {
            value: this.valueProp,
        }
    },

    mounted() {
        this.$root.$on('updateCity', (data) => {
            if ( data[1] === this.type )
                this.setCityValue(data[0]);
        });
    },

    methods: {
        setCityValue(zipId) {
            axios.post('/api/backend/city', { zipId: zipId })
                .then( response => this.value = response.data.city.city )
                .catch( error => console.log(error) );
        }
    }
}
</script>

<style scoped lang="scss">
div {
    cursor: not-allowed;
}
input {
    pointer-events: none;
    border-color: lighten(#505050, 50%) !important;
}
</style>
